import React from "react";
import { ImageIcon, Wrapper } from "./styles";

// import { Container } from './styles';

interface IconMoreOptionsProps {
  imageSrc?: string;
  onClick?: () => void;
  mouseLeave?: (any: any) => void;
  onMouseEnter?: (any: any) => void;
}

const IconMoreOptions: React.FC<IconMoreOptionsProps> = ({
  imageSrc,
  onClick,
  mouseLeave,
  onMouseEnter,
  ...rest
}) => {
  return (
    <>
      <Wrapper
        onMouseLeave={mouseLeave}
        onMouseEnter={onMouseEnter}
        {...rest}
        onClick={onClick}
      >
        <ImageIcon src={imageSrc} />
      </Wrapper>
    </>
  );
};

export default IconMoreOptions;

